import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Typography, Box, Tooltip } from '@mui/material'
import Input from '@mui/material/Input'
import photoIcon from 'src/assets/icons/photoIcon.png'
import videoIcon from 'src/assets/icons/videoIcon.png'
import fileUploadBorder from 'src/assets/icons/fileUploadBorder.png'
import styles from './index.module.scss'

const Image = styled('img')`
  height: 250px;
  object-fit: cover;
  margin-bottom: ${(props) => props.theme.spacing(2)};
`

const Video = styled('video')`
  height: 250px;
  width: 100%;
  object-fit: cover;
  margin-bottom: ${(props) => props.theme.spacing(2)};
`;

export interface AddBusinessDirectoryModalProps {
  open: boolean
  onClose: () => void
}

// Define a custom styled file input component

// Define the props interface for the styled file input component
interface StyledFileInputProps {
  type: 'image' | 'video' | 'file'
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  multiple?: boolean
  title: string
  discription: string
  name: string
  value: File | null
  required?: boolean
  // accept?: string
  showPreview?: boolean
}

// Define the styled file input component
const FileInput: React.FC<StyledFileInputProps> = ({
  onChange,
  multiple = false,
  title,
  discription,
  name,
  value,
  required = false,
  showPreview = false,
  type,
}) => {

  let accept = ''
  let icon
  if (type === 'image') {
    accept = 'image/png, image/jpg, image/jpeg'
    icon = photoIcon
  }
  if (type === 'video') {
    accept = 'video/mp4, video/wav, video/mkv'
    icon = videoIcon
  }
  // add code to handle video and file type

  return (
    <label className={styles.wrapper}>
      <Input
        type='file'
        onChange={onChange}
        inputProps={{ accept: accept, multiple }}
        sx={{ display: 'none' }}
        name={name}
        required={required}
      />

      {value && showPreview ? (
        <Box textAlign='center'>
          <Tooltip title='Click to change file.'>
            <span>
              {
                type == 'image' && <Image src={URL.createObjectURL(value)} alt={title} />
              }
              {
                type == 'video' && <Video src={URL.createObjectURL(value)} controls/>
              }
            </span>
          </Tooltip>
        </Box>
      ) : (
        <>
          <Box display='flex' justifyContent='center'>
            <Box className={styles.iconWrapper}>
              <img src={icon} height={35} alt='add' />
            </Box>
          </Box>
          <Box mt={2} display='flex' flexDirection='column' alignItems='center' justifyContent='center' >
            <Typography variant='h4'>{title}</Typography>
            <Typography variant='subtitle1' component='p' textAlign='center'>
              {discription}
            </Typography>
          </Box>
        </>
      )}
    </label>
  )
}

export default FileInput
